import { Component, input, signal } from '@angular/core';

@Component({
  selector: 'app-card-information',
  template: `
    <article class="w-full shadow-sm rounded-lg overflow-hidden my-3">
      <header class="p-4 sm:p-6">
        <div class="flex items-center justify-between gap-3 rounded-t-lg bg-pae-purple-5 p-3">
          <h3 class="text-lg font-semibold text-pae-purple">
            {{ title() }}
          </h3>

          @if (collapsible()) {
            <button
              type="button"
              (click)="toggleCollapsed()"
              class="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-pae-grey-3 bg-white text-lg font-bold text-pae-bordeaux shadow-sm transition hover:bg-pae-grey-1"
              [attr.aria-expanded]="!collapsed()"
              [attr.aria-label]="collapsed() ? 'Expandir ' + title() : 'Colapsar ' + title()">
              {{ collapsed() ? '+' : '-' }}
            </button>
          }
        </div>

        @if (description() && !collapsed()) {
          <h5 class="p-3 text-pae-purple" [innerHTML]="description()"></h5>
        }
      </header>

      @if (!collapsed()) {
        <div class="px-4 pb-4 sm:px-6 sm:pb-6">
          <ng-content></ng-content>
        </div>
      }
    </article>
  `,
})
export class CardInformationComponent {
  public title = input.required<string>();
  public description = input<string | null>(null);
  public collapsible = input(false);
  public collapsed = signal(false);

  public toggleCollapsed(): void {
    if (!this.collapsible()) {
      return;
    }

    this.collapsed.update(value => !value);
  }
}
